import React from "react";

import { Icon } from "widgets";

import styles from "./CouponForm.module.scss";

const FormSection = ({
  stepId,
  sectionKey,
  title,
  subtitle,
  iconName,
  isCollapsed = false,
  onToggle,
  children,
  className = "",
  variant = "form",
}) => {
  const isFormSection = variant === "form";
  const isCollapsible = !isFormSection;
  const showBody = isFormSection || !isCollapsed;

  return (
    <section
      id={stepId ? `step-${stepId}` : undefined}
      className={`${
        isFormSection ? styles.formSection : styles.sidebarSection
      } ${isCollapsible && isCollapsed ? styles.formSectionCollapsed : ""} ${className}`}
    >
      <div
        className={
          isFormSection ? styles.sectionHeader : styles.sidebarSectionHeader
        }
      >
        {isFormSection && iconName && (
          <span className={styles.sectionIconWrap}>
            <Icon name={iconName} className={styles.sectionIcon} fontSize="small" />
          </span>
        )}
        <div className={styles.sectionHeading}>
          <div>
            <h2
              className={
                isFormSection ? styles.sectionTitle : styles.sidebarSectionTitle
              }
            >
              {title}
            </h2>
            {subtitle && isFormSection && (
              <p className={styles.sectionSubtitle}>{subtitle}</p>
            )}
          </div>
        </div>
        {isCollapsible && (
          <button
            type="button"
            className={styles.sectionToggle}
            onClick={() => onToggle?.(sectionKey ?? stepId ?? title)}
            aria-expanded={!isCollapsed}
            aria-label={isCollapsed ? `Expand ${title}` : `Minimize ${title}`}
          >
            <Icon
              name={isCollapsed ? "expandMore" : "expandLess"}
              fontSize="small"
            />
          </button>
        )}
      </div>
      {showBody && (
        <div
          className={
            isFormSection ? styles.sectionBody : styles.sidebarSectionBody
          }
        >
          {children}
        </div>
      )}
    </section>
  );
};

export default FormSection;
